import { styled } from "@mui/material/styles";

const BreadcrumbWrapper = styled("div")(({ theme }) => ({
  background:
    "linear-gradient(285.48deg, rgba(107, 107, 107, 0.2) 10.84%, rgba(187, 187, 187, 0.2) 89.16%)",
  border: "0.25px solid rgba(30, 39, 56, 0.2)",
  boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.08)",
  padding: "10px 10px",
  display: "flex",
  alignItems: "center",
  "& .link": {
    width: "40%",
    "& a": {
      display: "flex",
      gap: "5px",
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "22px",
      color: "#0B0B0B",
      fontFamily: theme.typography.fontFamily,
      textDecoration: "none",
      alignItems: "center",
      border: "none",
      background: "transparent",
      cursor: "pointer",
    },
  },

  "& .breadcrumb": {
    width: "60%",
    "& ul": {
      listStyle: "none",
      display: "flex",
      gap: "10px",
    },
    "& ul li": {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "13px",
      lineHeight: "20px",
      letterSpacing: "0.05rem",
      color: "rgba(12, 12, 12, 0.5)",
      textTransform: "capitalize",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      "& svg": {
        fontSize: "15px",
      },
    },
    "& ul li:last-child": {
      color: "#0B0B0B",
      "& svg": {
        display: "none",
      },
    },
  },
}));

export { BreadcrumbWrapper };
